/* eslint-disable no-nested-ternary */
import React, { useMemo } from 'react'
import { Formik, Form } from 'formik'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import i18n from 'i18next'
import {
  Button,
  Card,
  ContentSection,
  Fieldset,
} from '@vwfs-bronson/bronson-react'
import * as Yup from 'yup'
import get from 'lodash/get'
import getInitialValues from './initial-values'
import DataProtectionFieldset from './Fieldset'
import { getFormData } from '../../../services/redux/features/form.redux'
import { getStorefrontData } from '../../../services/redux/features/storefront.redux'
import { getTlsValid } from '../../../services/redux/features/custom.redux'
import { setDataPrivacy } from '../../../services/analytics/functions'
import SummaryVehicleSection from '../SummaryVehicleSection'
import SummarySection from '../SummarySection'
import SummaryContractSectionVTI from '../SummaryContractSectionVTI'
import { getOriginSystem } from '../../../services/common/utils'
import { VALIDATION_ERRORS } from '../PersonalDetails/validation-schema'
import { FirstUsage } from '../../../models/enums'
const DataProtection = (props, ref) => {
  const {
    tlsValid,
    storefrontData,
    hasDefectsSelected,
    validateAllForms,
    finishJourney,
    isBusiness,
    isVtiGis,
    setIsDirty: setIsDirtyParent,
    hasSubmited,
    getValues,
  } = props
  let submitFunction
  React.useImperativeHandle(ref, () => ({
    submit: () => {
      submitFunction()
    },
    getData: () => {
      return formState.current.formProps.values
    },
    validate: () => {
      return formState.current.formProps.isValid
    },
  }))

  const { formData } = props
  const formState = React.useRef({})
  const [isSubmiting, setSubmiting] = React.useState(false)
  const [isDirty, setIsDirty] = React.useState(false)
  const { t } = useTranslation()

  const handleSubmit = async (e, formProps) => {
    setSubmiting(true)
    hasSubmited(true)
    Object.keys(formProps.values).forEach((field) => {
      formProps.setFieldTouched(field)
    })
    e.preventDefault()
    const isPersonalDataFilled = await validateAllForms()
    const {
      allowPersonalizedMarketing,
      allowPhoneAds,
      allowMailAds,
      acceptVehicleDefects,
      acceptVehicleDifferences,
      acceptLimitationPeriodVti,
      acceptFirstUsage,
      acceptPrecontractualInformationVti,
      acceptPurchaseConditionsVti,
      acceptInsuranceDocuments,
      acceptSalesTerms,
    } = formProps.values
    if (isPersonalDataFilled && formProps.isValid) {
      setDataPrivacy(formProps.values)
      finishJourney({
        allowPhoneAds,
        allowMailAds,
        allowPersonalizedMarketing,
        acceptVehicleDefects,
        acceptVehicleDifferences,
        acceptLimitationPeriodVti,
        acceptFirstUsage,
        acceptPrecontractualInformationVti,
        acceptPurchaseConditionsVti,
        acceptInsuranceDocuments,
        acceptSalesTerms,
      })
    }
  }

  const originSystem = useMemo(() => getOriginSystem(storefrontData), [storefrontData])

  const onSubmit = (values, actions) => {
    // updateValidSections('dataProtection', true)
    actions.setSubmitting(false)
  }

  const onChange = async (e, formProps) => {
    if (e?.target?.name === 'allowAllAds') {
      formProps.setValues({
        ...formProps.values,
        allowAllAds: e.target.checked,
        allowPhoneAds: e.target.checked,
        allowMailAds: e.target.checked,
        allowPersonalizedMarketing: e.target.checked,
      })
    } else {
      const { target } = e
      const { name } = target
      if (name) {
        const value = target.type === 'checkbox' ? target.checked : target.value
        await formProps.setFieldValue(name, value)
        await formProps.setFieldTouched(name)
      }
    }
  }

  const ValidationSchemaVtiGis = Yup.object().shape({
    acceptVehicleDifferences: Yup.boolean()
      .required(
        VALIDATION_ERRORS.valueRequired(
          i18n.t('form:dataProtection:vtiGis:deviationAgreeTitle')
        )
      )
      .oneOf(
        [true],
        VALIDATION_ERRORS.valueRequired(
          i18n.t('form:dataProtection:vtiGis:deviationAgreeTitle')
        )
      ),
    acceptLimitationPeriodVti: Yup.boolean()
      .required(
        VALIDATION_ERRORS.valueRequired(
          i18n.t('form:vehicleCondition:titleLimitationPeriod')
        )
      )
      .oneOf(
        [true],
        VALIDATION_ERRORS.valueRequired(
          i18n.t('form:vehicleCondition:titleLimitationPeriod')
        )
      ),
    ...(storefrontData?.vehicleData?.firstUsage === FirstUsage.RENTAL_CAR && {
      acceptFirstUsage: Yup.boolean()
        .required(
          VALIDATION_ERRORS.valueRequired(i18n.t('form:dataProtection:title'))
        )
        .oneOf(
          [true],
          VALIDATION_ERRORS.valueRequired(i18n.t('form:dataProtection:title'))
        ),
    }),
    acceptPrecontractualInformationVti: Yup.boolean()
      .required(
        VALIDATION_ERRORS.valueRequired(i18n.t('form:dataProtection:title'))
      )
      .oneOf(
        [true],
        VALIDATION_ERRORS.valueRequired(i18n.t('form:dataProtection:title'))
      ),
    acceptPurchaseConditionsVti: Yup.boolean()
      .required(
        VALIDATION_ERRORS.valueRequired(i18n.t('form:dataProtection:title'))
      )
      .oneOf(
        [true],
        VALIDATION_ERRORS.valueRequired(i18n.t('form:dataProtection:title'))
      ),
    acceptInsuranceDocuments: Yup.boolean()
      .required(
        VALIDATION_ERRORS.valueRequired(i18n.t('form:dataProtection:title'))
      )
      .oneOf(
        [true],
        VALIDATION_ERRORS.valueRequired(i18n.t('form:dataProtection:title'))
      ),
  })

  React.useEffect(() => {
    setIsDirtyParent(isDirty)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirty])

  React.useEffect(() => {
    if (isSubmiting) {
      setTimeout(() => {
        const firstError = document.querySelector('[aria-invalid=true]')
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
          firstError.focus()
        }
        setSubmiting(false)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmiting])

  React.useEffect(() => {
    formState.current.formProps.validateForm()
  }, [tlsValid])

  React.useEffect(() => {
    formState.current.formProps.validateForm()
  }, [hasDefectsSelected])

  return (
    <>
      <Formik
        initialValues={getInitialValues(formData, storefrontData)}
        validationSchema={
          isVtiGis ? ValidationSchemaVtiGis : null
        }
        onSubmit={onSubmit}
      >
        {(formProps) => {
          setIsDirty(formProps.dirty)
          formState.current = { formProps }
          return (
            <Form
              id="data-protection-form"
              onChange={(e) => onChange(e, formProps)}
              onSubmit={(e) => handleSubmit(e, formProps)}
            >
              <DataProtectionFieldset
                inspectionReportLink={
                  get(storefrontData, 'vehicleData.appraisals[0].url') || '#'
                }
                isBusiness={isBusiness}
                isVtiGis={isVtiGis}
                t={t}
                hasDefectsSelected={hasDefectsSelected}
              />
              <ContentSection className="u-pt-small u-pb-small">
                <Card title="">
                  <SummarySection
                    isBusiness={isBusiness}
                    isVtiGis={isVtiGis}
                    getValues={getValues}
                    storefrontData={storefrontData}
                  />
                </Card>
              </ContentSection>
              <ContentSection className="u-pt-small u-pb-small">
                <Card title="" className="u-text-left">
                  <SummaryVehicleSection
                    purchaseDate={
                      storefrontData.financialProduct?.confirmedPurchaseDate
                    }
                    vehicleData={storefrontData.vehicleData}
                    isVtiGis={isVtiGis}
                    isBusiness={isBusiness}
                    selectedCondition={formData?.condition}
                    defectsDescription={formData?.defectsDescription}
                  />
                  {!isVtiGis && (
                    <Fieldset.Row className="u-text-right u-mt-large">
                      <Button
                        className="u-text-center"
                        testId="nextButton"
                        type="button"
                        onClick={(e) => {
                          handleSubmit(e, formProps)
                        }}
                      >
                        {t(`summaryVehicle:${originSystem}:nextButton`, { defaultValue: t(`summaryVehicle:default:nextButton`) })}
                      </Button>
                    </Fieldset.Row>
                  )}
                </Card>
              </ContentSection>
              {isVtiGis && (
                <ContentSection className="u-pt-small u-pb-small">
                  <Card title="" className="u-text-left">
                    <SummaryContractSectionVTI
                      vehicleData={storefrontData.vehicleData}
                      financialProduct={storefrontData.financialProduct}
                    />
                    <Fieldset.Row className="u-text-right u-mt-large">
                      <Button
                        className="u-text-center"
                        testId="nextButton"
                        type="button"
                        onClick={(e) => {
                          handleSubmit(e, formProps)
                        }}
                        data-modal="demo-modal"
                      >
                        {t(`summaryVehicle:${originSystem}:nextButton`, { defaultValue: t(`summaryVehicle:default:nextButton`) })}
                      </Button>
                    </Fieldset.Row>
                  </Card>
                </ContentSection>
              )}
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formData: getFormData(state),
    tlsValid: getTlsValid(state),
    showVWDSEData: true,
    storefrontData: getStorefrontData(state),
  }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  React.forwardRef(DataProtection)
)
